import(/* webpackMode: "eager" */ "/app/src/app/(main)/[locale]/(all)/(lobby)/games/template.tsx");
